(function () {
  'use strict';

  var mediaSelector = 'img, picture, canvas';

  function hasUrlBackground(element, pseudoElement) {
    var backgroundImage = window.getComputedStyle(element, pseudoElement).backgroundImage;
    return backgroundImage && backgroundImage.indexOf('url(') !== -1;
  }

  function isProtectedTarget(target) {
    if (!(target instanceof Element)) return false;
    if (target.closest(mediaSelector)) return true;

    var element = target;
    while (element && element !== document.body && element !== document.documentElement) {
      if (
        hasUrlBackground(element, null) ||
        hasUrlBackground(element, '::before') ||
        hasUrlBackground(element, '::after')
      ) {
        return true;
      }
      element = element.parentElement;
    }

    return false;
  }

  function blockImageAction(event) {
    if (isProtectedTarget(event.target)) event.preventDefault();
  }

  document.documentElement.classList.add('rm-image-guard');
  document.addEventListener('contextmenu', blockImageAction, true);
  document.addEventListener('dragstart', blockImageAction, true);
})();
